import { render, staticRenderFns } from "./ProtospellingDisplay.vue?vue&type=template&id=bda3f8fc&"
import script from "./ProtospellingDisplay.vue?vue&type=script&lang=js&"
export * from "./ProtospellingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports